import { RegisterModel } from "../../models/RegisterModel";
import { CountryInfo } from "../../models/CountryInfo";


export interface IRegisterProps {
    mode?: "" | "update";
}

export interface IRegisterState {
    model: RegisterModel;
    isValid: boolean;
    isMobileValid: boolean,
    countries: CountryInfo[];
    status?: RegisterStatus;
    code?: string;
    mode?: "" | "update" | "companyName";
}

export enum RegisterStatus {
    EnterPhone,
    ConfirmNumber,
    Register
}


// WEBPACK FOOTER //
// ./routes/register/IRegister.ts